import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import es from './locales/es.json'

/** The platform ships bilingual from v1: drivers and dispatchers pick their own language. */
export const supportedLanguages = {
  en: 'English',
  es: 'Español',
} as const

export type SupportedLanguage = keyof typeof supportedLanguages

/**
 * Keeps <html lang> in sync with the active language. Screen readers pick their voice
 * and pronunciation from it, and the browser stops offering to translate a page that
 * is already in the reader's language.
 */
function syncDocumentLanguage(language: string): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language
  }
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: Object.keys(supportedLanguages),
    interpolation: { escapeValue: false }, // React already escapes
  })
  .then(() => syncDocumentLanguage(i18n.resolvedLanguage ?? 'en'))

i18n.on('languageChanged', syncDocumentLanguage)

export default i18n
